// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".selcted-clinic-record td {\n  background-color: #b9e9fc;\n}", "",{"version":3,"sources":["webpack://./src/app/sections/doctor/doctor-clinics/select-clinic/select-clinic.component.scss"],"names":[],"mappings":"AAAA;EACG,yBAAA;AACH","sourcesContent":[".selcted-clinic-record td{\r\n   background-color: #b9e9fc;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
